import ItodoImage from "../../../elements/itodo-img";
import { NavLink } from "react-router-dom";

const clientLogos = [
    "images/client-logo/africaoilbv.png",
    "images/client-logo/arcangel.png",
    "images/client-logo/bloomberg.png",
    "images/client-logo/gulfenergy.png",
    "images/client-logo/kokonetworks.png",
    "images/client-logo/lolldaigaconservancy.png",
    "images/client-logo/salamafikirainternational.png",
    "images/client-logo/teitaestate.png",
    "images/client-logo/tullow.png",
];

function SectionClients2({ hideTitle }) {
    return (
        <>
            <div className="section-full p-t110 p-b80 sx-client-logo-1-outer sx-bg-white">
                <div className="container">
                    {/* TITLE START */}
                    {
                        (hideTitle === undefined ||
                            hideTitle === null ||
                            !hideTitle) &&
                        <div className="section-head center max-900">
                            <div className="sx-head-s-title">Our Clients</div>
                            <div className="sx-head-l-title">
                                <h2 className="sx-title2">Trusted by project stakeholders, private principals, and operational partners across the region.</h2>
                            </div>
                        </div>
                    }

                    {/* TITLE END */}
                    <div className="section-content">
                        <div className="client-grid m-b30">
                            <div className="row justify-content-center">
                                {clientLogos.map((logoSrc) => (
                                    <div key={logoSrc} className="col-lg-3 col-md-4 col-sm-6 col-6">
                                        <NavLink to="/contact-us" className="client-logo-pic">
                                            <ItodoImage src={logoSrc} alt="Client logo" />
                                            <div>
                                                <span className="sx-circle-btn"><i className="fa fa-long-arrow-right" /></span>
                                            </div>
                                        </NavLink>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SectionClients2;
